/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable prefer-template */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-console */
import React, {useState, useEffect} from 'react';
import Axios from 'axios'
import { Link , useHistory} from 'react-router-dom'; 

export default function UserTokens(){
    const history = useHistory();
    const [tokens_list, set_tokens_list] = useState([])
 
    const get_all_tokens_list=()=>{ 

        const token_data={
            bnb_wallet_address: localStorage.getItem("token_address")
        }

        Axios.post("https://api.arrano.network/tokens/tokens_list", token_data)
        .then((response: any)=>{  
                if(response.data.status){
                    set_tokens_list(response.data.message)
                }
                else{
                    history.push("/market");
                }
        })
    }

    useEffect(()=>{
        get_all_tokens_list()
    },[history])

    const Enabletoken=(id: any)=>{
        const token_data={
            request_row_id: id
        }

        Axios.post("https://api.arrano.network/tokens/enable_token", token_data)
        .then((response: any)=>{  
            get_all_tokens_list()
        })
    }

    const Disabletoken=(id: any)=>{
        const token_data={
            request_row_id: id
        }

        Axios.post("https://api.arrano.network/tokens/disable_token", token_data)
        .then((response: any)=>{  
            get_all_tokens_list()
        })
    }


    return(
        <div className="container">
                <div className="row">
                    <div className="col-md-8">
                        <h4 className="mt-3 market_title">Manage Tokens</h4>
                        <p>Here you can manage your tokens</p>
                    </div>
                    <div className="col-md-4">
                        <Link className="list_coin_button" to="/market/list-your-coin">List your Coin</Link>
                    </div>
                </div>
            <div className="user_tokens">
                <div className="market_exchange ">
                    <div className="table-responsive">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                <th>Coin name</th>
                                <th>Coin symbol</th>
                                <th>Email ID</th>
                                <th>Contract address</th>
                                <th>Approval status</th>
                                <th>Action</th>
                                </tr>
                            </thead>
                            <tbody> 
                                {
                                    tokens_list.length > 0
                                    ?
                                        tokens_list.map((e: any) => {
                                            return <tr>
                                            <td>{e.coin_name}</td>
                                            <td>{e.coin_symbol}</td>
                                            <td>{e.email_id}</td>
                                            <td>{e.contract_address}</td>
                                            <td>{
                                                    e.approval_status === "0"
                                                    ?
                                                    <span className="badge badge-warning">Pending</span>
                                                    :
                                                    <span className="badge badge-success">Approved</span>
                                                }</td>
                                            <td>
                                                {
                                                    e.coin_status === "1"
                                                    ?
                                                    <span className="action_btn" onClick={()=>Disabletoken(e.id)}><i className="fas fa-eye-slash" /></span>
                                                    :
                                                    <span className="action_btn" onClick={()=>Enabletoken(e.id)}><i className="fas fa-eye" /></span> 
                                                }
                                                <span className="action_btn"><Link to={"/market/update-token/"+e.contract_address}><i className="fas fa-edit" /></Link></span> 
                                            </td>
                                        </tr>
                                        }
                                    )
                                    :
                                    <td>No Tokens Found!</td>
                                }

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}